import React from "react";
import "./errorPage.css";
import { Link } from "react-router-dom";
const ErrorPage = (props) => {
  return (
    <div className="container-fluid">
      <div id="notfound">
        <div className={props.code === "404" ? "notfound" : "notfound not-top"}>
          <div className="notfound-404">
            <h1>:(</h1>
          </div>
          <h2>
            {props.code === "404"
              ? "404 - Page not found"
              : "401 - Unauthorized Acess"}
          </h2>
          <p>
            {props.code === "404"
              ? "The page you are looking for might have been removed had its name changed or is temporarily unavailable."
              : " You don't have the necessary permissions to access this page"}
          </p>
          <Link className="btn btn-primary" to="/dashboard">
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
